import Client from '../../helpers/ApiClient';
import Component from '../Component';
import DatePicker from 'reactis-monthpicker';
import {Button} from 'react-bootstrap';
import React from 'react';
import Moment from 'moment';

export default class MonthPagePicker extends Component {

	static rules = DatePicker.rules;

	static defaultProps = {
		type: 'month'
	};

	handleClickPage(page) {
		if (!this.props.value) {
			return;
		}
		const value = new Moment(this.props.value).add(page, this.props.type).format('YYYY-MM-DD');
		if (this.props.onChange) {
			this.props.onChange(value)
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	}

	render() {
		return <span>
					<Button onClick={() => this.handleClickPage(-1)} style={{height: 29, marginRight: 4}}>
						<span className="fa fa-caret-left"></span>
					</Button>
					<span style={{position:'relative', top: 1}}>
					<DatePicker {...this.props} clearable={false} />
					</span>
					<Button onClick={() => this.handleClickPage(1)} style={{height: 29, marginLeft: 4}}>
						<span className="fa fa-caret-right"></span>
					</Button>
				</span>
	}

}




// WEBPACK FOOTER //
// ./src/components/Form/MonthPagePicker.js